// mantine
import { Badge, List } from '@mantine/core';
// components
import { NumberFormatter } from '@newo/ui-kit';
import { Check } from 'lucide-react';
import { TBillingSubscriptionInfo } from '@newo/api/gateway';
import UnitsProgress from '@/pages/Profile/components/Billing/components/UnitsProgress';
import BillingMenu from '@/pages/Profile/components/Billing/components/BillingMenu';
// icons
// utils
import { formatDate } from '@/utils/format';

interface ActiveSubscriptionProps {
    data: TBillingSubscriptionInfo;
    unitsSpent: number;
    onCancel: () => void;
    isCancelPending: boolean;
}

const CENTS_IN_DOLLAR = 100;

const ActiveSubscription = ({
    data,
    unitsSpent,
    onCancel
}: ActiveSubscriptionProps) => {
    const nextPaymentDate = formatDate(data.subscription_end, 'MMM D, YYYY');
    return (
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr] gap-4">
            <div>
                <div className="text-xl font-bold mb-4 flex items-start gap-2">
                    <div>{data.product_name}</div>

                    <Badge
                        className="capitalize shrink-0 mt-1"
                        color="green"
                        variant="light"
                    >
                        Active
                    </Badge>
                </div>
                <List center icon={<Check />} size="sm" spacing="sm">
                    <List.Item>
                        Next payment is due on {nextPaymentDate}.
                    </List.Item>
                    <List.Item>
                        Your subscription renews automatically each month,
                    </List.Item>
                </List>
            </div>
            <div className="flex flex-col justify-between items-end gap-4">
                <BillingMenu onCancel={onCancel} />
                <div className="flex gap-4 w-full">
                    <UnitsProgress
                        className="flex-1"
                        max={data.product_units}
                        min={0}
                        value={unitsSpent}
                    />
                    <div className="text-xs text-gray-6">
                        <div className="mb-1">Extra Units Price</div>
                        <div className="font-bold text-gray-9 text-sm rounded-md bg-gray-2 py-1 text-center">
                            <NumberFormatter
                                prefix="$"
                                value={data.unit_price_amount / CENTS_IN_DOLLAR}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActiveSubscription;
